import { afterValid } from '~/services/api/contracts/afterValid'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { time } from '~/services/api/contracts/time'
import { NotificationPreferencesUpdateRequestSchema2 } from '~/services/api/generated'

interface StoredQuietHours {
  readonly stored_quiet_hours_enabled: boolean
  readonly stored_quiet_hours_end: string
  readonly stored_quiet_hours_start: string
}

const body = NotificationPreferencesUpdateRequestSchema2.extend({
  notification_settings:
    NotificationPreferencesUpdateRequestSchema2.shape.notification_settings.extend({
      quiet_hours_end: time.optional(),
      quiet_hours_start: time.optional()
    })
})

const hasStoredQuietHours = (context: StoredQuietHours | NoContext): context is StoredQuietHours =>
  'stored_quiet_hours_enabled' in context

// Without stored quiet hours the start/end rule applies only to values the body carries.
export const NotificationPreferencesUpdate = (context: StoredQuietHours | NoContext) =>
  afterValid(body, (value, ctx) => {
    const settings = value.notification_settings
    const stored = hasStoredQuietHours(context) ? context : undefined
    const enabled = settings.quiet_hours_enabled ?? stored?.stored_quiet_hours_enabled
    const start = settings.quiet_hours_start ?? stored?.stored_quiet_hours_start
    const end = settings.quiet_hours_end ?? stored?.stored_quiet_hours_end

    if (
      enabled === true &&
      start !== undefined &&
      end !== undefined &&
      start.slice(0, 5) === end.slice(0, 5)
    ) {
      ctx.addIssue({
        code: 'custom',
        message: 'Quiet hours start and end times must be different',
        path: ['notification_settings', 'quiet_hours_enabled']
      })
    }
  })
